import { useEffect } from "react";

const CHATBOT_SCRIPT_ID = "genesis-chatbot-widget";

export default function ChatbotWidget() {
    useEffect(() => {
        if (document.getElementById(CHATBOT_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement("script");
        script.id = CHATBOT_SCRIPT_ID;
        script.src =
            "https://chatbot.genesisrecovery.ai/staticfiles/widget/genesisbot.c9fa7ee2542f.js?v=18";
        script.defer = true;
        script.dataset.botId = "53124371-c32f-468d-82f2-3fcf00b4d65d";
        script.dataset.apiKey =
            "gnb_live_HlkNm7_EM-3MJL6TRHNSyiOCetiOe2GGTofXeME_kC7VIbhNM0ab1A";
        script.dataset.host = "https://chatbot.genesisrecovery.ai";
        script.dataset.title = "Ask H.O.P.E";

        document.body.appendChild(script);

        return () => {
            document.getElementById(CHATBOT_SCRIPT_ID)?.remove();
        };
    }, []);

    return null;
}
